import {
  CancellationType,
  CancellationTypeValue,
  Confirmation,
  buildCancelShiftAction,
} from '@nextforce/api'
import { t } from 'app/i18l'
import { useRoutingContext } from 'app/routing_context'
import { CancelShiftScreenProps } from 'home/stack/types'
import React, { useCallback } from 'react'
import { Keyboard } from 'react-native'
import { errorAlert } from 'shared/alerts'
import { usePerformShiftAction } from 'shifts/queries/perform_action'
import CancelShiftView from 'shifts/screens/cancel_shift/view'
import { useShiftActions } from 'shifts/shift_actions_context'

export function CancelShiftScreen({ navigation }: CancelShiftScreenProps) {
  const { actionCommand, setActionCommand } = useShiftActions()
  const { handleNavigation } = useRoutingContext()
  const shiftMutation = usePerformShiftAction()
  const confirmation: Confirmation = {
    title: 'Cancel this Shift?',
    message:
      'You are about to cancel this shift. The crew member and other managers will be notified.',
  }

  const cancellationTypes: CancellationType[] =
    actionCommand?.action.params?.sub_type.split('|')
  const cancellationData = cancellationTypes.map((type, index) => {
    switch (type) {
      case 'MANAGER_INITIATED':
        return { type, text: 'Manager wants to cancel', id: index }
      case 'MANAGER_INITIATED_FOR_HELPER':
        return { type, text: 'Crew Member wants to cancel', id: index }
      case 'NO_SHOW':
        return { type, text: 'No Show', id: index }
    }
  })

  const onButtonPress = useCallback(
    async (cancelTypeValue: CancellationTypeValue) => {
      Keyboard.dismiss()
      const action = buildCancelShiftAction(
        actionCommand?.action!,
        cancelTypeValue
      )

      try {
        const shiftData = await shiftMutation.mutateAsync(action)

        if (shiftData) {
          handleNavigation({
            routeName: 'confirm_shift_action',
            routeParams: { shiftData },
          })
        }
      } catch (err: any) {
        errorAlert(err, t('cancelShiftErrorTitle'))
      }
    },
    [actionCommand?.action, handleNavigation, shiftMutation]
  )

  return (
    <CancelShiftView
      {...{ cancellationData, onButtonPress }}
      command={
        actionCommand?.confirmation
          ? actionCommand
          : { ...actionCommand!, confirmation }
      }
    />
  )
}
